import React, { Component, Fragment } from "react";
import axios from "axios";
import { PropagateLoader } from "react-spinners";
import { isEmail, isEmpty } from "validator";

const loaderStyle = {
  display: "flex",
  flex: 1,
  flexDirection: "row",
  justifyContent: "center"
};

export default class MailchimpSignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fname: "",
      lname: "",
      email: "",
      petType: "",
      isSubmitting: false,
      error: "",
      success: false
    };

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleFormSubmit = async e => {
    e.preventDefault();
    this.setState({ isSubmitting: true, error: "" });
    try {
      let submitData = this.state;
      delete submitData.isSubmitting;
      delete submitData.error;
      let errors = [];
      if (isEmpty(submitData.fname)) {
        errors.push("First name can't be empty");
      } else if (isEmpty(submitData.lname)) {
        errors.push("Last name can't be empty");
      } else if (isEmpty(submitData.email)) {
        errors.push("Email can't be empty");
      } else if (!isEmail(submitData.email)) {
        errors.push("Invalid format email provided");
      }

      if (errors.length > 0) {
        this.setState({ isSubmitting: false, error: errors[0] });
        console.log(errors);
        return null;
      }

      // post to /user/subscriber
      await axios.post("/user/subscribe", submitData).then(response => {
        console.log("response after submit: ", response);
        this.setState({
          isSubmitting: false,
          success: true,
          fname: "",
          lname: "",
          email: "",
          petType: ""
        });

        setTimeout(() => {
          this.setState({ success: false });
        }, 3000);
      });
    } catch (err) {
      console.log("error on posting form : ", err);
      this.setState({
        isSubmitting: false,
        error: "There was error saving information"
      });
    }
  };

  handleInputChange(element, field) {
    let updateState = {};
    updateState[`${field}`] = element.target.value;
    this.setState(updateState);
  }

  render() {
    const {
      fname,
      lname,
      email,
      petType,
      isSubmitting,
      error,
      success
    } = this.state;
    return (
      <div id="mc_embed_signup">
        {success && (
          <div className="alert alert-success" style={{ width: "80%" }}>
            <p>You're in!</p>
          </div>
        )}
        <form
          onSubmit={this.handleFormSubmit}
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="validate"
          target="_blank"
          noValidate
        >
          <div id="mc_embed_signup_scroll">
            <div className="mc-field-group">
              <label htmlFor="mce-FNAME" className="sr-only">
                First Name <span className="asterisk">*</span>
              </label>
              <input
                type="text"
                value={fname}
                name="FNAME"
                placeholder="First Name*"
                className="required"
                id="mce-FNAME"
                onChange={e => {
                  this.handleInputChange(e, "fname");
                }}
              />
            </div>
            <div className="mc-field-group">
              <label htmlFor="mce-LNAME" className="sr-only">
                Last Name <span className="asterisk">*</span>
              </label>
              <input
                type="text"
                value={lname}
                name="LNAME"
                placeholder="Last Name*"
                className="required"
                id="mce-LNAME"
                onChange={e => {
                  this.handleInputChange(e, "lname");
                }}
              />
            </div>
            <div className="mc-field-group">
              <label htmlFor="mce-EMAIL" className="sr-only">
                Email Address <span className="asterisk">*</span>
              </label>
              <input
                type="email"
                value={email}
                name="EMAIL"
                placeholder="Email*"
                className="required email"
                id="mce-EMAIL"
                onChange={e => {
                  this.handleInputChange(e, "email");
                }}
              />
            </div>
            <div className="mc-field-group">
              <label htmlFor="mce-MMERGE11" className="sr-only">
                Pet Type{" "}
              </label>
              <select
                name="MMERGE11"
                className="mailchimp-pets"
                placeholder="Pet Type"
                value={petType}
                id="mce-MMERGE11"
                onChange={e => {
                  this.handleInputChange(e, "petType");
                }}
              >
                <option value="Dog">Dog</option>
                <option value="Cat">Cat</option>
                <option value="Rabbit">Rabbit</option>
                <option value="Guinea Pig">Guinea Pig</option>
                <option value="Bird">Bird</option>
                <option value="Rat">Rat</option>
                <option value="Mouse">Mouse</option>
                <option value="Snake">Snake</option>
                <option value="Turtle">Turtle</option>
                <option value="Unicorn">Unicorn</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div id="mce-responses" className="clear">
              <div
                className="response"
                id="mce-error-response"
                style={{ display: "none" }}
              />
              <div
                className="response"
                id="mce-success-response"
                style={{ display: "none" }}
              />
            </div>
            <div
              style={{ position: "absolute", left: "-5000px" }}
              aria-hidden="true"
            >
              <input
                type="text"
                name="b_e2691d5791144cfd7f3b5c93d_5bccdb1ed4"
                tabIndex="-1"
              />
            </div>
            <div className="clear">
              {error !== "" && (
                <Fragment>
                  <span
                    className="alert alert-danger"
                    style={{ display: "block" }}
                  >
                    {error}
                  </span>
                </Fragment>
              )}

              <input
                type="submit"
                value="Join our community"
                name="subscribe"
                id="mc-embedded-subscribe"
                className="btn btn-vetchat2"
                disabled={isSubmitting}
              />

              {isSubmitting && (
                <div style={loaderStyle}>
                  <PropagateLoader color={"#36D7B7"} />
                </div>
              )}
            </div>
          </div>
        </form>
      </div>
    );
  }
}
